import { render, staticRenderFns } from "./IDForgotComplete.vue?vue&type=template&id=e402cb52&scoped=true"
import script from "./IDForgotComplete.vue?vue&type=script&lang=js"
export * from "./IDForgotComplete.vue?vue&type=script&lang=js"
import style0 from "./IDForgotComplete.vue?vue&type=style&index=0&id=e402cb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e402cb52",
  null
  
)

export default component.exports